// extracted by mini-css-extract-plugin
export var legendIndicator = "_as-1";
export var legendRight = "_as-0";